module.exports = __webpack_public_path__ + "static/media/logo_white.950c4a01.svg";